
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'

// module components
import PretensionFiles from '@/modules/PretensionsModule/components/PretensionFiles/index.vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// composable
import { useRoute } from 'vue-router'

// types
import { Complaint } from '@/new-services/types/complaints'

// @new-services
import complaintsAPI from '@/new-services/complaints.service'

import { formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    components: {
        PageTitle,
        TheButton,
        FailedFetch,
        Loader,
        Cheap,
        PretensionFiles,
    },
    setup() {
        const route = useRoute()
        const id = Number(route.params.id)

        const state = reactive({
            is_loading: false,
            is_failed: false,
            //
            complaint: null as Complaint | null,
        })

        const loadComplaint = async () => {
            try {
                state.is_loading = true

                const response = await complaintsAPI.getComplaint(id)
                state.complaint = response.data.data

                state.is_failed = false
            } catch (error) {
                console.error(error)
                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        // computed

        const isType41 = computed(
            () => state.complaint && state.complaint.type && state.complaint.type.id === 41
        )
        const isType42 = computed(
            () => state.complaint && state.complaint.type && state.complaint.type.id === 42
        )

        //

        onBeforeMount(loadComplaint)

        //

        return {
            state,
            //
            loadComplaint,
            //
            isType41,
            isType42,
            formatDateFromBackend,
        }
    },
})
